import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { AppBar, Avatar, Button, Typography, Toolbar } from "@material-ui/core";
import decode from "jwt-decode";

import memories from "../../images/memories.png";
import useStyles from "./styles.js";
import { signOut } from "../../actions/auth";
import { SIGNIN } from "../../reducers/user";

const NavBar = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    console.log("Nav bar use effect");
    const currentUserResult = localStorage.getItem("user");
    const currentUser = JSON.parse(currentUserResult);
    if (currentUser) {
      const token = currentUser.token;
      const decodedToken = decode(token);
      if (decodedToken.exp * 1000 < new Date().getTime) {
        dispatch(signOut());
      } else {
        dispatch(SIGNIN(currentUser));
      }
    }
  }, [dispatch]);
  const user = useSelector((state) => {
    return state.user.profile;
  });
  console.log('nav bar local user:', user);
  const onSignOutTapped = () => {
    console.log("log out tapped");
    dispatch(signOut());
  }
  const classes = useStyles();
  return (
    <AppBar className={classes.appBar} position="static" color="inherit">
      <div className={classes.brandContainer}>
        <Typography component={Link} to="/" className={classes.heading} variant="h2" align="center">Lobbies</Typography>
        <img className={classes.image} src={memories} alt="lobbies" height="60" />
      </div>
      <Toolbar className={classes.toolbar}>
        {user ? (
          <div className={classes.profile}>
            <Avatar className={classes.purple} alt={user.name} src={user.imageUrl}>
              {user.name?.charAt(0)}
            </Avatar>
            <Typography className={classes.userName} variant="h6">
              {user.name}
            </Typography>
            <Button variant="contained" className={classes.logout} color="secondary" onClick={onSignOutTapped}>
              Logout
            </Button>
          </div>
        ) : (
          <Button component={Link} variant="contained" to="/auth" color="primary">
            Sign In
          </Button>
        )}
      </Toolbar>
    </AppBar>
  )
};

export default NavBar;